/**
 * @file useShopCard.ts
 * @description Карточка магазина платформы и её контекст для вкладок
 * (phase19.28 этап А; uiux-platform-shops §4–§6; вложенные маршруты, как в
 * questionnaire). Каркас (`ShopCardLayout`) грузит карточку один раз и
 * отдаёт её вкладкам через `Outlet context`; после мутаций вкладка зовёт
 * `reload` — данные перечитываются с сервера.
 */

import { useOutletContext } from "react-router";

import { platformShops, type ShopCard } from "../../lib/api-platform-shops";
import { usePlatformResource, type PlatformResource } from "./usePlatformResource";

export function useShopCardResource(shopId: string | undefined): PlatformResource<ShopCard> {
  return usePlatformResource(
    shopId ? `shops/${shopId}` : null,
    () => platformShops.get(shopId ?? ""),
    "Не удалось загрузить магазин. Проверьте соединение и повторите",
  );
}

/** Что каркас карточки отдаёт вкладкам. */
export interface ShopCardContext {
  shop: ShopCard;
  /** База адресов вкладок: `/platform/shops/<id>`. */
  base: string;
  reload: () => void;
  /** Открыть «Кабинет ↗» под владельцем (окно с причиной). */
  enterCabinet: (ownerId: string) => void;
}

export function useShopCardContext(): ShopCardContext {
  return useOutletContext<ShopCardContext>();
}
